import { Grid } from '@material-ui/core'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import DialogForm from '../DialogForm'
import Select from '../SelectForm'
import CommonTextField from '../TextFieldForm'

ProductForm.propTypes = {
  open: PropTypes.bool,
  onValidate: PropTypes.func,
  onClose: PropTypes.func,
  categories: PropTypes.array,
  rates: PropTypes.array,
  initForm: PropTypes.object,
  updateForm: PropTypes.bool,
}

export default function ProductForm({ open, onClose, onValidate, title, categories, rates, initForm, updateForm }) {
  const [form, setForm] = useState({})

  const [errors, setErrors] = useState({
    name: false,
    code: false,
    category: false,
    rate: false,
  })

  useEffect(() => {
    if (initForm) {
      setForm({ ...initForm })
    }
  }, [initForm])

  function _handleChange(target) {
    setErrors({ ...errors, [target.name]: target.value === '' })

    setForm((prevForm) => ({
      ...prevForm,
      [target.name]: target.value,
    }))
  }

  function _handleValidate() {
    if (!errors.name && !errors.code && !errors.category && form.category !== 0 && form.code && form.name) {
      onValidate(form)
      setForm({ ...initForm })
    }
  }
  return (
    <>
      <DialogForm update={updateForm} open={open} onValidate={_handleValidate} onClose={onClose} title={title}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={9}>
            <CommonTextField
              name="name"
              required
              value={form.name}
              onChange={(e) => _handleChange(e.target)}
              label="Nom"
              error={errors.name}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <CommonTextField
              name="code"
              required
              value={form.code}
              onChange={(e) => _handleChange(e.target)}
              label="Code"
              error={errors.code}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Select
              name="category"
              value={form.category}
              required
              label="Catégorie"
              onChange={(e) => _handleChange(e.target)}
              items={categories}
              valueName="id"
              text="name"
              error={errors.category}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Select
              name="rate"
              select
              value={form.rate}
              onChange={(e) => _handleChange(e.target)}
              label="Taux"
              items={rates}
              valueName="id"
              text="value"
            />
          </Grid>
        </Grid>
      </DialogForm>
    </>
  )
}
